import axios from 'axios';
import client from './client';

// Set default base URL
axios.defaults.baseURL =  process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

// Login API
export const loginApi = async ({ email, password, remember }) => {
  try {
    const { data } = await client.post('/users/auth/login', { email, password, remember });
    return data;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

export const meApi = async () => {
  const { data } = await client.get('/users/auth/me');
  return data;
};

export const registerApi = async ({ firstName, lastName, email, password, company }) => {
  const { data } = await client.post('/users/auth/register', { firstName, lastName, email, password, company });
  return data;
};

export const verifyEmailApi = async ({ token, email }) => {
  const { data } = await client.get('/users/auth/verify', { params: { token, email } });
  return data;
};

export const resendVerificationApi = async ({ email }) => {
  const { data } = await client.post('/users/auth/resend-verification', { email });
  return data;
};

export const logoutApi = async () => {
  const { data } = await client.post('/users/auth/logout');
  return data;
};


